import { render } from "./CardDescriptionField.vue?vue&type=template&id=9bfb7048"
import script from "./CardDescriptionField.vue?vue&type=script&lang=js"
export * from "./CardDescriptionField.vue?vue&type=script&lang=js"

import "./CardDescriptionField.vue?vue&type=style&index=0&id=9bfb7048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__